<div class="transaction-type" [class]="SecurityTransactionType[transactionType]">
  <span>{{ transactionType | securityTransactionType | splitByCapitalLetterPipe }}</span>
</div>
